/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { SmsChannelDto } from '../models/sms-channel-dto';

@Injectable({
  providedIn: 'root',
})
export class SmsChannelControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getAllSmsChanels
   */
  static readonly GetAllSmsChanelsPath = '/api/v1/channels';

  /**
   * Get SMS channels.
   *
   * The API to get SMS channels
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSmsChanels()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSmsChanels$Response(params?: {
  }): Observable<StrictHttpResponse<Array<SmsChannelDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SmsChannelControllerService.GetAllSmsChanelsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SmsChannelDto>>;
      })
    );
  }

  /**
   * Get SMS channels.
   *
   * The API to get SMS channels
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSmsChanels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSmsChanels(params?: {
  }): Observable<Array<SmsChannelDto>> {

    return this.getAllSmsChanels$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SmsChannelDto>>) => r.body as Array<SmsChannelDto>)
    );
  }

}
